// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1irzm","colBig":"styles_colBig__u4Jl2","colSmall":"styles_colSmall__1BFmX"};